/* unplugin-vue-components disabled */import script from "./generateImg.vue?vue&type=script&setup=true&lang=js"
export * from "./generateImg.vue?vue&type=script&setup=true&lang=js"

import "./generateImg.vue?vue&type=style&index=0&id=1d95f967&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d95f967"]])

export default __exports__